import type { SvgComponent } from '@/types/SvgComponent';

export const XIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M18.75 5.25L5.25 18.75"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.5 18.5L5 5" stroke="currentColor" strokeWidth="1.13" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
